import React, { useEffect, useCallback, useState } from "react";
import { Row, Col, Modal, Radio, Typography } from "antd";
import { connect } from "react-redux";
import { useIntl } from "react-intl";

import SendResult from "./sendResult";
import LabelPositionSelect from "./labelPositionSelect";

import "./index.css";
import InfoLabel from "../../app/generic/infoLabel";

const { Title } = Typography;

function ConsignmentPrintModal({
  sendResult,
  modalVisible,
  consignmentIds,
  setModalVisible,
}) {
  const intl = useIntl();
  const [canBePrinted, setCanBePrinted] = useState();
  useEffect(() => {
    setCanBePrinted(
      !sendResult ||
        (sendResult.countOfValid > 0 && sendResult.countOfInvalid === 0)
    );
  }, [sendResult]);

  const [selectedLabelPosition, setSelectedLabelPosition] = useState(0);
  const handleSelectedLabelPosition = useCallback(
    (idx) => setSelectedLabelPosition(idx),
    []
  );

  const [showPositionSelect, setShowPositionSelect] = useState(true);
  const [selectedPrint, setSelectedPrint] = useState(3);
  const onPrintTypeChange = useCallback((e) => {
    setShowPositionSelect(e.target.value === 2 || e.target.value === 3);
    setSelectedPrint(e.target.value);
    setSelectedLabelPosition(0);
  }, []);

  const handleCancelModal = useCallback(() => {
    setModalVisible(false);
  }, [setModalVisible]);

  const [printLoading, setPrintLoading] = useState();
  const stopLoading = useCallback(() => {
    setPrintLoading(false);
  }, [setPrintLoading]);

  const stopLoadingAndHideModal = useCallback(() => {
    stopLoading();
    setModalVisible(false);
  }, [stopLoading, setModalVisible]);

  const handlePrint = useCallback(() => {
    if (consignmentIds && consignmentIds.length > 0) {
      setPrintLoading(true);
      import("../../../modules/prints/consignmentPrints").then((module) => {
        if (selectedPrint === 0) {
          module.printZplLabel(
            consignmentIds,
            stopLoading,
            stopLoadingAndHideModal
          );
        } else if (
          selectedPrint === 1 ||
          selectedPrint === 2 ||
          selectedPrint === 3 ||
          selectedPrint === 4 ||
          selectedPrint === 5
        ) {
          module.printing(
            consignmentIds,
            selectedPrint,
            stopLoading,
            stopLoadingAndHideModal,
            selectedLabelPosition
          );
          setTimeout(() => setSelectedLabelPosition(0), 2000);
        }
      });
    }
  }, [
    stopLoading,
    selectedPrint,
    consignmentIds,
    selectedLabelPosition,
    stopLoadingAndHideModal,
  ]);

  return (
    <Modal
      okText={intl.formatMessage({
        id: "messages.print",
        defaultMessage: "Tisk",
      })}
      onOk={handlePrint}
      title={intl.formatMessage({
        id: "messages.printOffer",
        defaultMessage: "Nabídka tisku",
      })}
      visible={modalVisible}
      onCancel={handleCancelModal}
      confirmLoading={printLoading}
      width={showPositionSelect ? 700 : 520}
      okButtonProps={canBePrinted ? {} : { className: "display-none" }}
    >
      <Row>
        <Col span={showPositionSelect && canBePrinted ? 14 : 24}>
          <SendResult sendResult={sendResult} />
          {canBePrinted && (
            <Row gutter={[0, 50]}>
              <Col span={10}>
                <Radio.Group
                  defaultValue={selectedPrint}
                  onChange={onPrintTypeChange}
                >
                  <Title level={4}>
                    {intl.formatMessage({
                      id: "consignment.print.label",
                      defaultMessage: "Štítek zásilky",
                    })}
                  </Title>
                  <Radio className="vertical-radio-group" value={0} disabled>
                    {intl.formatMessage({
                      id: "consignment.print.zplLabel",
                      defaultMessage:
                        "Tisk štítku ve formátu ZPL (labelová tiskárna)",
                    })}
                  </Radio>
                  <Radio className="vertical-radio-group" value={1}>
                    {intl.formatMessage({
                      id: "consignment.print.pdfLabel",
                      defaultMessage:
                        "Tisk štítku formát 4x6.5&quot; – 1 etiketa (labelová tiskárna, pdf)",
                    })}
                  </Radio>
                  <Radio className="vertical-radio-group" value={2}>
                    {intl.formatMessage({
                      id: "consignment.print.label3",
                      defaultMessage:
                        "Tisk štítku formát A4 – 3 etikety (klasická tiskárna)",
                    })}
                  </Radio>
                  <Radio className="vertical-radio-group" value={3}>
                    {intl.formatMessage({
                      id: "consignment.print.label4",
                      defaultMessage:
                        "Tisk štítku formát A4 – 4 etikety (klasická tiskárna)",
                    })}
                  </Radio>
                  <Title level={4} className="h4-margin-top">
                    {intl.formatMessage({
                      id: "consignment.print.consignentList",
                      defaultMessage: "Seznam zásilek",
                    })}
                  </Title>
                  <Radio className="vertical-radio-group" value={4}>
                    {intl.formatMessage({
                      id: "consignment.print.printConsignentList",
                      defaultMessage: "Tisk seznamu zásilek",
                    })}
                  </Radio>
                  <Title level={4} className="h4-margin-top">
                    {intl.formatMessage({
                      id: "consignment.print.euroLine",
                      defaultMessage: "EuroLine",
                    })}
                    <InfoLabel
                      info={intl.formatMessage({
                        id: "consignment.print.euroLineLimitation",
                        defaultMessage:
                          "Pouze pro zásilky s produktem ELI a ELD",
                      })}
                    />
                  </Title>
                  <Radio className="vertical-radio-group" value={5}>
                    {intl.formatMessage({
                      id: "consignment.print.euroLineCmr",
                      defaultMessage: "CMR",
                    })}
                  </Radio>
                </Radio.Group>
              </Col>
            </Row>
          )}
        </Col>
        <Col span={showPositionSelect && canBePrinted ? 10 : 0}>
          <LabelPositionSelect
            landscape={selectedPrint === 2}
            selectedPosition={selectedLabelPosition}
            onSelectedPosition={handleSelectedLabelPosition}
          />
        </Col>
      </Row>
    </Modal>
  );
}

const mapStateToProps = ({ client }) => ({
  client: client.data,
});

export default connect(mapStateToProps, null)(ConsignmentPrintModal);
